import Vue from "vue";
import VueRouter, { RouteConfig, Route } from "vue-router";
import { AuthModule } from "./store/auth";
import gAuth from "vue-google-oauth2";
Vue.use(VueRouter);
import Vuex from "vuex";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    authenticated: false,
  },
  mutations: {
    setAuthentication(state, status) {
      state.authenticated = status;
    },
  },
});

declare module "vue-router" {
  interface RouteConfig {
    auth?: boolean;
  }
}
declare module "vue/types/vue" {
  interface Vue {
    $route: Route;
  }
  interface VueConstructor {
    $route: Route;
  }
}

// Prefix the route name with layout name
// Layouts can be found inside src/pages/layout
const routes: Array<any> = [
  {
    path: "/dashboard",
    name: "main.home",
    // redirect: "/",
    // route level code-splitting
    // this generates a separate chunk (home.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ "@/pages/Home.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        // next.push({ name: "main.login_page" });
        // next({ name: "main.login_page" });
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/conversation/:ConversationId/",
    name: "main.conversation",

    component: () => import("@/pages/ChapterList.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },
  {
    path: "/grammar/:CategoryId/",
    name: "main.grammar",

    component: () => import("@/pages/GrammarChapterList.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/grammar/:CategoryId/:ChapterId/",
    name: "main.grammar_chapter",
    component: () => import("@/pages/GrammarChapter.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/conversation/:ConversationId/:ChapterId/",
    name: "main.chapter",
    component: () => import("@/pages/Chapter.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/conversation/exercise/:ConversationId/:ExerciseId/",
    name: "main.conversation_exersice",
    component: () => import("@/pages/ConversationExercise.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  // {
  //   path: "/:Category/:ConversationId/",
  //   name: "main.category",
  //   component: () => import("@/pages/SubCategory.vue"),
  //   meta: {
  //     keepAlive: false,
  //   },
  // },
  {
    path: "/words/:CategoryId/",
    name: "main.words_level",
    component: () => import("@/pages/WordsLevel.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/words/:CategoryId/:LevelId/",
    name: "main.single_level",
    component: () => import("@/pages/WordList.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/exercise/:Category/:CategoryId/:ExerciseId/",
    name: "main.exercise",
    component: () => import("@/pages/Exercise.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/exercise/:Category/:CategoryId/:LevelId/",
    name: "main.level_wise_exercise",
    component: () => import("@/pages/Exercise.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/conversation_category/",
    name: "main.conversation_category",
    component: () => import("@/pages/ConversationCategory.vue"),
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
    meta: {
      keepAlive: false,
    },
  },

  {
    path: "/words_category/",
    name: "main.words_category",
    component: () => import("@/pages/WordsCategory.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },
  {
    path: "/grammar_category/",
    name: "main.grammar_category",
    component: () => import("@/pages/GrammarCategory.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/podcasts/",
    name: "main.podcasts",
    component: () => import("@/pages/Podcast.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },
  {
    path: "/podcasts/episodes/:CategoryId/",
    name: "main.episodes",
    component: () => import("@/pages/EpisodeList.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },
  {
    path: "/podcasts/:CategoryId/:EpisodeId/",
    name: "main.episode",
    component: () => import("@/pages/Episode.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },
  {
    path: "/dictionary/",
    name: "main.dictionary",
    component: () => import("@/pages/Dictionary.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },
  {
    path: "/word_of_the_month/",
    name: "main.word_of_the_month",
    component: () => import("@/pages/WordOfTheMonth.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/word_of_the_day/:day/",
    name: "main.word_of_the_day",
    component: () => import("@/pages/WordOfTheDay.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },
  {
    path: "/translations/",
    name: "main.translations",
    component: () => import("@/pages/Translations.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/reports/",
    name: "main.reports",
    component: () => import("@/pages/Reports.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/users/",
    name: "main.users",
    component: () => import("@/pages/Users.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },
  {
    path: "/search_data/",
    name: "main.search_data",
    component: () => import("@/pages/SearchData.vue"),
    meta: {
      keepAlive: false,
    },
    beforeEnter: (to: Route, from: Route, next: any) => {
      if (localStorage.getItem("UserLoggedIn") == "true") {
        next();
      } else {
        next({
          name: "main.login_page",
        });
        return;
      }
    },
  },

  {
    path: "/",
    name: "main.login_page",
    component: () => import("@/pages/LoginPage.vue"),

    meta: {
      keepAlive: false,
    },
  },
  // {
  //   path: "/dictionary",
  //   name: "main.dictionary",
  //   component: () => import("@/pages/Dictionary.vue"),

  //   meta: {
  //     keepAlive: false,
  //   },
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;

// Setup Auth Gaurd
router.beforeEach((to, from, next) => {
  const route = routes.find((x) => x.name === to.name);
  if (!route) {
    router.push({
      path: "/error",
      query: {
        code: "404",
        redirect: "/",
        message: "Page not found",
        details: `This page does not exists in our site: "${to.path}"`,
      },
    });
  }
  if (route?.auth && !AuthModule.isLoggedIn) {
    router.push({
      path: "/error",
      query: {
        code: "403",
        redirect: "/",
        message: "You are not unauthorized",
        details: `You tried to access "${to.path}" without logging in first`,
      },
    });
  }
  next();
});
